import React, { useState } from 'react'
import { Form, Input, Button, Checkbox, Row, Col, Select } from 'antd';
import FileBox from '../../components/file';
import { connect } from 'react-redux';
import {updateProductImage} from '../../actions/product';

const { Option } = Select;
const UpdateImage = ({updateProductImage,id, close, fnc, type}) => {
    const [isExpireable, setIsExpireable] = useState('')
    const onFinish = async (values) => {
        const res = await updateProductImage(values, id, type)
        if(res === 201){
            fnc()
            close()
        }
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    return ( 
        <Form
            name="basic"
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
    >
                <FileBox
                    label="Upload Product Thumbnail (300X300)"
                    name="thumbnail"
                    
                />

                <br />
                <Form.Item
                    // wrapperCol={{
                    // offset: 1,
                    // span: 22,
                    // }}
                    style={{textAlign: 'center'}}
                >
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
    </Form>
     );
}
 
export default connect(null,{updateProductImage})(UpdateImage);